import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NzImageModule, NzImageService } from 'ng-zorro-antd/image';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import { FileApiService } from '../../../services/apis/file-api.service';

@Component({
  selector: 'app-product-images-carousel',
  imports: [
    NgOptimizedImage,
    FileurlPipe,
    MatIconModule,
    NzImageModule,
    NgClass
  ],
  templateUrl: './product-images-carousel.html',
  styleUrl: './product-images-carousel.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductImagesCarousel {
  @Input({ required: true }) images: string[] = [];

  index: number = 0;

  constructor(
    private imageService: NzImageService,
    private fileApi: FileApiService
  ) { }

  choose(index: number) {
    this.index = index;
  }

  get currentImage(): string {
    return this.images[this.index];
  }
  preview() {
    this.imageService.preview(this.images.map((image) => {
      return {
        src: this.fileApi.fileurl(image),
      };
    })).switchTo(this.index);
  }

}
